/** sessionStorage keys for 2FA step-1 pre-auth JWT (avoids long tokens in URL). */
export const STAFF_2FA_PREAUTH_STORAGE_KEY = 'lusuku_staff_2fa_preauth';
export const PARTNER_2FA_PREAUTH_STORAGE_KEY = 'lusuku_partner_2fa_preauth';
